import React, { useState } from 'react'
import { Modal, Form, Input, Button, message, Radio, InputNumber } from 'antd'
import ModalCustom from '../common/Modal/ModalCustom'
import { getPakageCommunity } from '../../services/pakage-community-service'

const ModalAddMoney = ({ visible, onCancel, onAddMoney }) => {
  const [form] = Form.useForm()

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      onAddMoney(values)
      form.resetFields()
    } catch (error) {
      console.log('Validation failed:', error)
    }
  }

  return (
    <ModalCustom
      title="Thêm tiền/Thu hồi tiền tài khoản"
      open={visible}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            form.resetFields()
            onCancel()
          }}
        >
          Hủy
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Xác nhận
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="horizontal"
        labelAlign="left"
        labelCol={{ span: 8 }}
        style={{
          // maxHeight: '80vh',
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        initialValues={{
          account_type: 1,
          type: 'ADD'
        }}
      >
        <Form.Item label="Tài khoản" name="account_type">
          <Radio.Group>
            <Radio value={1}>Tài khoản chính</Radio>
            <Radio value={2}>Tài khoản khuyến mãi</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="Loại giao dịch" name="type">
          <Radio.Group >
            <Radio value={'ADD'}>Thêm tiền</Radio>
            <Radio value={'SUB'}>Thu hồi</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="Số tiền" name="amount">
          <InputNumber
            placeholder="Nhập số tiền"
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'amount',
                  value: e.target.value?.trim()
                }
              ])
            }}
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
            parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
            maxLength={255}
            style={{width: '100%'}}
          />
        </Form.Item>
      </Form>
    </ModalCustom>
  )
}

export default ModalAddMoney
